import { Box, makeStyles } from "@material-ui/core";
import React, { useContext } from "react";
import { HourlyDataContext } from "../../Contexts/HourlyDataContext";
import BranchItem from "./BranchItem";
import CreateBranchItem from "./CreateBranchItem";

const useStyles = makeStyles((theme) => ({
  flexColContainer: {
    display: "flex",
    flexDirection: "column",
  },
  flexColItem: {
    marginBottom: theme.spacing(2),
  },
  flexRowContainer: {
    display: "flex",
  },
  flexRowItem: {
    flexGrow: 1,
    width: "100%",
    // whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

const AssignBranchInputComponent = ({ value, setValue, week }) => {
  const { createBranchModel } = useContext(HourlyDataContext);
  const branchModel = createBranchModel({ week });
  const classes = useStyles();

  const handleCreate = (branchObj) => setValue([branchObj, ...value]);
  const handleDelete = (branchObj) =>
    setValue(value.filter((e) => e !== branchObj));

  return (
    <Box className={classes.flexColContainer}>
      <CreateBranchItem
        className={classes.flexColItem}
        branchModel={branchModel}
        createItem={handleCreate}
      />
      {value.map((branchObj) => (
        <BranchItem
          className={classes.flexColItem}
          key={Math.random()}
          branchModel={branchModel}
          branchObj={branchObj}
          deleteItem={handleDelete}
        />
      ))}
    </Box>
  );
};

export default AssignBranchInputComponent;
